import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ChildNotes } from "../components/children/ChildNotes";
// import { UserHeader } from "../components/UserHeader";
import styles from "./css/ChildDetails.module.css";
import { safeLogger } from "../utils/logger";
import { baseURL } from "../services/axios";

export const ChildNotesPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [childName, setChildName] = useState(location.state?.childName || "");
  const [childCode, setChildCode] = useState<number | null>(null);

  useEffect(() => {
    // אם אין שם או קוד ילד מהניווט, נטען מהשרת
    if ((!childName || !childCode) && id) {
      fetch(`${baseURL}/child/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then(res => res.json())
        .then(data => {
          setChildName(`${data.fname} ${data.lname}`);
          setChildCode(data.code);
        })
        .catch(() => {
          setChildName("שם הילד");
          safeLogger.error("Failed to load child details");
        });
    }
  }, [childName, childCode, id]);

  return (
    <>
      {/* <UserHeader /> */}
      <div className={styles.pageContainer}>
        <div className={styles.container}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '15px'
          }}>
            {/* הכפתור חזרה לפרטי הילד הוסר */}
          </div>

          {childCode ? (
            <ChildNotes childCode={childCode} childName={childName} />
          ) : (
            <div style={{ textAlign: 'center', padding: '30px' }}>טוען נתונים...</div>
          )}
        </div>
      </div>
    </>
  );
};
